module.exports = __webpack_public_path__ + "img/BPP_branco.89ba5361.png";